<template>
    <span>
        <b-form-select v-if="!readonly" class="form-control" v-model="v" :options="options" :readonly="readonly" @input="input" @change="input"></b-form-select>
        <b-form-input v-if="readonly" :value="GetSelectedText" :readonly="readonly"></b-form-input>
    </span>
</template>
<script>
    
    export default {
        name: 'lformselect',
        props: [ 'value', 'options', 'readonly' ],
        data() {
            return {
                v:null,
                searchFor:null
            }
        },
        created() {
            this.v = this.value;
        },
        watch: {
            value: function () {
                this.v = this.value;
            },
            v: function() {
                if(this.v)
                    this.input();
            }
        },
        computed: {
            GetSelectedText: function () {
                if(this.options) {
                    let opt = this.options.find(x=>x.value == this.v);
                    if(opt)
                        return opt.text;
                }
                if(this.readonly)
                    return `[${this.v}]`;                    
            }
        },
        methods: {
            input() {
                this.$emit('input', this.v);
            }
        }
    }

</script>